export class Auth {
    userName: string;
    password: string;
    role: string;
    oneSignal: string;
    lang: string;
    constructor() {
        this.userName = '';
        this.password = '';
        this.lang = 'en';
        this.role = 'customer';
    }
}
